import React, { useEffect, useState } from 'react';
import './QRCodeDisplay.css';

function QRCodeDisplay({ qrCode, onClose }) {
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getQRCodeImage = () => {
    // O QR Code pode vir em diferentes formatos dependendo da versão do Evolution API
    if (qrCode.qrcode?.base64) {
      return qrCode.qrcode.base64;
    }
    if (qrCode.base64) {
      return qrCode.base64;
    }
    if (qrCode.qrcode?.code) {
      return qrCode.qrcode.code;
    }
    if (qrCode.code) {
      return qrCode.code;
    }
    return null;
  };

  const qrImage = getQRCodeImage();

  return (
    <div className="qrcode-overlay" onClick={onClose}>
      <div className="qrcode-modal" onClick={(e) => e.stopPropagation()}>
        <div className="qrcode-header">
          <h2>Escanear QR Code</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="qrcode-content">
          {qrImage ? (
            <>
              <div className="qrcode-image-container">
                <img
                  src={qrImage.startsWith('data:') ? qrImage : `data:image/png;base64,${qrImage}`}
                  alt="QR Code"
                  className="qrcode-image"
                />
              </div>

              <div className="qrcode-instructions">
                <h3>Como conectar:</h3>
                <ol>
                  <li>Abra o WhatsApp no seu celular</li>
                  <li>Toque em <strong>Mais opções</strong> ou <strong>Configurações</strong></li>
                  <li>Selecione <strong>Aparelhos conectados</strong></li>
                  <li>Toque em <strong>Conectar um aparelho</strong></li>
                  <li>Aponte seu celular para esta tela para escanear o QR Code</li>
                </ol>
              </div>

              {countdown > 0 && (
                <div className="qrcode-timer">
                  O QR Code expira em: <strong>{countdown}s</strong>
                </div>
              )}

              {countdown === 0 && (
                <div className="qrcode-expired">
                  QR Code expirado. Feche e gere um novo.
                </div>
              )}
            </>
          ) : (
            <div className="qrcode-error">
              Erro ao carregar QR Code. Tente novamente.
            </div>
          )}
        </div>

        <div className="qrcode-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default QRCodeDisplay;
